import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-cloud-remove",
  "use": "icon-si-glyph-cloud-remove-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-cloud-remove\" id=\"icon-si-glyph-cloud-remove\"><title>854</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(0.000000, 5.000000)\" fill=\"#434343\"><path d=\"M7.965,5.991 L7.965,3.987 L13.016,3.953 L13.016,5.984 L16.01,5.951 C15.87,4.521 14.948,3.412 13.821,3.412 C13.569,3.412 13.333,3.479 13.107,3.58 C12.413,2.54 11.276,1.86 9.989,1.86 C9.782,1.86 9.581,1.882 9.384,1.916 C8.702,0.783 7.515,0.03 6.159,0.03 C4.249,0.03 2.669,1.527 2.38,3.481 C2.362,3.481 2.346,3.475 2.329,3.475 C1.048,3.475 0.011,4.583 0.011,5.951 L7.965,5.991 L7.965,5.991 Z\" class=\"si-glyph-fill\" /><rect x=\"9\" y=\"5\" width=\"2.959\" height=\"0.99\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-cloud-remove.svg
// module id = 9unX
// module chunks = 62